import { notifications } from '@mantine/notifications';

interface NotificationOptions {
  title?: string;
  message: string;
  autoClose?: number | false;
  position?:
    | 'top-left'
    | 'top-right'
    | 'top-center'
    | 'bottom-left'
    | 'bottom-right'
    | 'bottom-center';
}

export default function useNotification() {
  const showSuccessNotification = (
    message: string,
    options?: Omit<NotificationOptions, 'message'>
  ) => {
    notifications.show({
      title: options?.title || 'Success',
      message,
      color: 'green',
      position: options?.position || 'top-right',
      autoClose: options?.autoClose ?? 5000,
    });
  };

  const showWarningNotification = (
    message: string,
    options?: Omit<NotificationOptions, 'message'>
  ) => {
    notifications.show({
      title: options?.title || 'Warning',
      message,
      color: 'yellow',
      position: options?.position || 'top-right',
      autoClose: options?.autoClose ?? 5000,
    });
  };

  const showErrorNotification = (
    message: string,
    options?: Omit<NotificationOptions, 'message'>
  ) => {
    notifications.show({
      title: options?.title || 'Error',
      message,
      color: 'red',
      position: options?.position || 'top-right',
      autoClose: options?.autoClose ?? 5000,
    });
  };

  const showInfoNotification = (
    message: string,
    options?: Omit<NotificationOptions, 'message'>
  ) => {
    notifications.show({
      title: options?.title || 'Info',
      message,
      color: 'blue',
      position: options?.position || 'top-right',
      autoClose: options?.autoClose ?? 5000,
    });
  };

  return {
    showSuccessNotification,
    showWarningNotification,
    showErrorNotification,
    showInfoNotification,
  };
}
